<template>
  <v-card class="modal-participantes dialog">
    <v-form ref="form" v-model="valid" @submit.prevent="salvar">
      <v-card-title class="primary">
        <span class="headline modal-participantes-titulo">CORRETAGEM DOS PARTICIPANTES</span>
      </v-card-title>
      <v-card-text class="py-3 px-4">
        <div
          grid-list-md
          v-for="participante of participanteList"
          :key="participante.key"
        >
          <v-layout wrap class="pt-4" pb-2>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                required
                :rules="regras.notNull"
                :disabled="camposBloqueados(participante)"
                height="50px"
                v-model="participante.idTipoPessoa"
                row
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1">Tipo pessoa</span>
                <v-layout>
                  <v-flex
                    d-inline-flex
                    align-center
                    v-for="item in tipoPessoaList"
                    :key="item.id"
                    ><v-radio :label="item.titulo" :value="item.id"> </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-layout align-center>
                <v-tooltip
                  right
                  max-width="260"
                  :disabled="tooltipDesabilitado(participante)"
                >
                  <v-icon
                    slot="activator"
                    class="mr-2 icone-instrucional"
                    :color="
                      tooltipDesabilitado(participante) ? 'grey lighten-1' : 'primary'
                    "
                  >
                    info
                  </v-icon>
                  <span>
                    Preencha o campo CPF/CNPJ e complemente os demais campos
                    liberados
                  </span>
                </v-tooltip>
                <v-text-field
                  :mask="
                    participante.cnpjCpf && participante.cnpjCpf.length <= 11
                      ? '###.###.###-###'
                      : 'NN.NNN.NNN/NNNN-##'
                  "
                  v-model="participante.cnpjCpf"
                  label="CPF/CNPJ"
                  required
                  :rules="[...regras.notNull, ...regras.cnpjCpf]"
                  :disabled="somenteLeitura"
                  :loading="participante.buscandoCorretor"
                  @blur="buscarCorretor(participante)"
                >
                </v-text-field>
              </v-layout>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                v-model="participante.razaoSocial"
                label="Nome/Razão Social"
                required
                :rules="regras.notNull"
                :disabled="camposBloqueados(participante)"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-text-field
              type="enderecoEmail"
              v-model="participante.enderecoEmail"
              label="E-mail"
              required
              :rules="regras.notNull"
              :disabled="camposBloqueados(participante)"
            >
            </v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="participante.enderecoTelefone"
              mask="(##) #####-####"
              label="Telefone (com DDD)"
              browser-autocomplete="off"
              required
              :rules="regras.notNull"
              :disabled="camposBloqueados(participante)"
            >
            </v-text-field>
            <v-spacer></v-spacer>
          </v-layout>
          <v-layout class="pb-4" row wrap>
            <v-flex xs12 sm5 md2>
              <v-text-field
                v-model="participante.numeroSusep"
                mask="#########"
                label="Número SUSEP"
                required
                :rules="regras.notNull"
                :disabled="camposBloqueados(participante)"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-select
                label="Tipo Co-corretagem"
                :items="tipoCoCorretagemList"
                v-model="participante.idTipoCoCorretagem"
                item-text="titulo"
                item-value="id"
                required
                :rules="regras.notNull"
                :disabled="camposBloqueados(participante)"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                v-if="!ocultarCamposCorretagemAphicor || !ocultarCamposCorretagemOutrosParticipantes && (!verificarSeERazaoSocialAphicor(participante.razaoSocial))"
                v-model="participante.coCorretagem"
                label="Co-corretagem (%)"
                required
                :rules="regras.notNull"
                :disabled="camposBloqueados(participante)"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-radio-group
                v-if="!ocultarCamposCorretagemAphicor || !ocultarCamposCorretagemOutrosParticipantes && (!verificarSeERazaoSocialAphicor(participante.razaoSocial))"
                required
                :rules="regras.notNull"
                :disabled="camposBloqueados(participante) || bloquearCamposCorretorLider"
                height="50px"
                v-model="participante.corretorLider"
                row
                class="my-0 pt-0"
              >
                <span class="themeGrey--text body-1">Corretor líder</span>
                <v-layout>
                  <v-flex
                    d-inline-flex
                    align-center
                    v-for="item in simOuNao"
                    :key="item.titulo"
                    ><v-radio :label="item.titulo" :value="item.value">
                    </v-radio
                  ></v-flex>
                </v-layout>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-divider v-show="!somenteLeitura"></v-divider>
          <v-flex v-if="participanteList.length > 1">
            <v-btn @click="removerParticipante(participante.key)" class="mt-4 btn-modal-participantes" :disabled="somenteLeitura" flat>
              REMOVER PARTICIPANTE
            </v-btn>
          </v-flex>
        </div>
        <v-layout>
          <v-flex>
            <v-btn @click="adicionarParticipante" v-show="!somenteLeitura" class="mt-4 btn-modal-participantes" :disabled="somenteLeitura" flat>
              INCLUIR PARTICIPANTES
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="modal-participantes-buttons-sec py-4">
        <v-btn @click="fechar" flat color="primary ml-4">VOLTAR</v-btn>
        <v-btn v-if="!somenteLeitura" class="primary px-4" type="submit">SALVAR </v-btn>
      </v-card-actions>

      <v-dialog
        v-model="dialogParticipanteNaoEncontrado"
        max-width="560"
        persistent
      >
        <v-card>
          <v-card-title class="primary">
            <span class="headline modal-participantes-titulo">
              Participante não encontrado
            </span>
            <v-spacer></v-spacer>
            <v-btn icon flat @click="cancelarPreenchimentoManual">
              <v-icon color="white">close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="py-4 px-4">
            <p>O cadastro do participante não foi encontrado.</p>
            <p class="mb-0">
              Será necessário preencher todos os campos de forma manual.
            </p>
          </v-card-text>

          <v-card-actions class="pb-4 px-4">
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="cancelarPreenchimentoManual">
              CANCELAR
            </v-btn>
            <v-btn class="primary px-4" @click="liberarPreenchimentoManual">
              PREENCHER MANUAL
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
        {{ snackText }}
        <v-btn flat @click="snack = false">Fechar</v-btn>
      </v-snackbar>

      <template>
        <v-layout row justify-center>
          <v-dialog v-model="dialogError" max-width="500">
            <v-card class="text-center">
              <v-card-title class="primary">
                <span class="headline">ERRO PARA EMITIR COTAÇÃO</span>
              </v-card-title>

              <h3 class="pa-3 text-xs-center">
                {{ errorMessage }}
              </h3>

              <v-card-text>
                <div
                  class="color pa-3"
                  v-for="(value, key) in errorDetails"
                  :key="key"
                >
                  <h4>{{ key }}:</h4>
                  <span v-for="(message, index) in value" :key="index">
                    {{ message }}
                  </span>
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="primary darken-1"
                  flat="flat"
                  @click="dialogError = false"
                >
                  Fechar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
    </v-form>
  </v-card>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import { mapState } from "vuex";

export default {
  name: "ModalParticipantes",

  data() {
    return {
      simOuNao: [
        {
          value: false,
          titulo: "Não"
        },
        {
          value: true,
          titulo: "Sim"
        }
      ],
      menu: false,
      snack: false,
      valid: false,
      snackColor: "",
      snackText: "",
      dialogError: false,
      dialogParticipanteNaoEncontrado: false,
      participanteNaoEncontrado: null,
      errorMessage: "",
      errorDetails: null,
      idApolice: null,
      tipoPessoaList: [],
      tipoCoCorretagemList: [],
      participanteList: [],
      regras: {
        notNull: [
          v =>
            (v !== null && v !== undefined && v !== "") ||
            "Você não pode deixar este campo em branco"
        ],
        cnpjCpf: [
          v =>
            !!String(v).match(/^([A-Za-z0-9]{12}\d{2}|\d{11})$/) || "CPF ou CNPJ incorreto"
        ],
        cep: [v => !!String(v).match(/^\d{8}$/) || "CEP incorreto"]
      },
      ocultarCamposCorretagemAphicor: false,
      ocultarCamposCorretagemOutrosParticipantes: false,
      bloquearCamposCorretorLider: false,
      RAZAO_SOCIAL_APHICOR: 'Aphicor Corretora e Administradora de Seguros Ltda.'
    };
  },

  props: {
    dialog: Boolean,
    camposInfoGerais: Object,
    participantes: Array,
    somenteLeitura: {
      type: Boolean,
      required: false
    }
  },
  computed: {},

  mounted() {
    this.verificarPermissoesUsuario();
    this.buscaOpcoes();
    if (this.participantes instanceof Array && this.participantes.length) {
      this.insterirParticipantes(this.participantes);
    } else {
      this.adicionarParticipante();
    }
  },

  methods: {
    verificarSeERazaoSocialAphicor(razaoSocial) {
      return razaoSocial === this.RAZAO_SOCIAL_APHICOR;
    },

    verificarPermissoesUsuario() {
      var usuario = usuarioHelper.USUARIO_LOGADO();
      if (usuario.perfil.descricao == 'Corretor Parceiro') {
        this.ocultarCamposCorretagemAphicor = true;
        this.ocultarCamposCorretagemOutrosParticipantes = false;
        this.bloquearCamposCorretorLider = true;
      } else {
        this.ocultarCamposCorretagemAphicor = false;
        this.ocultarCamposCorretagemOutrosParticipantes = false;
        this.bloquearCamposCorretorLider = false;
      }
    },

    adicionarParticipante() {
      this.participanteList.push({
        ...this.novoParticipante(),
        ...this.controleParticipante(true)
      });
    },

    insterirParticipantes(participanteList) {
      const keys = Object.keys(this.novoParticipante());
      this.participanteList = participanteList.map(item => ({
        ...keys.reduce((acc, cur) => {
          acc[cur] = item[cur];
          return acc;
        }, {}),
        ...this.controleParticipante(false)
      }));
    },

    controleParticipante(bloqueado) {
      return {
        key: Math.random(),
        camposBloqueadosParticipante: bloqueado,
        preenchimentoManual: false,
        buscandoCorretor: false,
        documentoConsultado: null
      };
    },

    camposBloqueados(participante) {
      return this.somenteLeitura || participante.camposBloqueadosParticipante;
    },

    tooltipDesabilitado(participante) {
      return this.somenteLeitura || participante.preenchimentoManual;
    },

    buscarCorretor(participante) {
      if (this.somenteLeitura || participante.preenchimentoManual) {
        return;
      }

      const documento = String(participante.cnpjCpf || "").replace(/\D/g, "");

      if (documento.length !== 11 && documento.length !== 14) {
        return;
      }

      if (documento === participante.documentoConsultado) {
        return;
      }

      participante.documentoConsultado = documento;
      participante.buscandoCorretor = true;

      axios
        .get(`${process.env.URL_ESSORMS}/v1/corretores?cpfCnpj=${documento}`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.preencherDadosCorretor(participante, response.data);
          participante.camposBloqueadosParticipante = false;
        })
        .catch(() => {
          this.participanteNaoEncontrado = participante;
          this.dialogParticipanteNaoEncontrado = true;
        })
        .finally(() => {
          participante.buscandoCorretor = false;
        });
    },

    preencherDadosCorretor(participante, corretor) {
      if (!corretor) {
        return;
      }

      participante.razaoSocial = corretor.razaoSocial || null;
      participante.numeroSusep = corretor.numeroSusep || null;
      participante.enderecoEmail = corretor.enderecoEmail || null;
      participante.enderecoTelefone = corretor.enderecoTelefone || null;
    },

    liberarPreenchimentoManual() {
      if (this.participanteNaoEncontrado) {
        this.participanteNaoEncontrado.camposBloqueadosParticipante = false;
        this.participanteNaoEncontrado.preenchimentoManual = true;
      }
      this.fecharDialogParticipanteNaoEncontrado();
    },

    cancelarPreenchimentoManual() {
      if (this.participanteNaoEncontrado) {
        this.participanteNaoEncontrado.cnpjCpf = null;
        this.participanteNaoEncontrado.documentoConsultado = null;
        this.participanteNaoEncontrado.camposBloqueadosParticipante = true;
      }
      this.fecharDialogParticipanteNaoEncontrado();
    },

    fecharDialogParticipanteNaoEncontrado() {
      this.dialogParticipanteNaoEncontrado = false;
      this.participanteNaoEncontrado = null;
    },

    novoParticipante() {
      return {
        id: null,
        idTipoPessoa: null,
        razaoSocial: null,
        cnpjCpf: null,
        enderecoEmail: null,
        enderecoTelefone: null,
        numeroSusep: null,
        idTipoCoCorretagem: null,
        coCorretagem: null,
        corretorLider: false
      };
    },

    removerParticipante(key) {
      this.participanteList = this.participanteList.filter(
        item => item.key != key
      );
    },

    salvar() {
      if (this.participanteList.length && this.$refs.form.validate()) {
        const keys = Object.keys(this.novoParticipante());
        const participantes = this.participanteList.map(participante =>
          keys.reduce(
            (acc, cur) => {
              acc[cur] = participante[cur];
              return acc;
            },
            { key: participante.key }
          )
        );
        this.$emit("salvar", participantes);
      }
    },

    buscaOpcoes() {
      ["tipoPessoa", "tipoCoCorretagem"].forEach(item => {
        axios
          .get(`${process.env.URL_APOLICEMS}/v1/${item}`, {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          })
          .then(response => {
            this[`${item}List`] =
              response.data instanceof Array ? response.data : [];
          })
          .catch(err => {
            console.error(err);
          });
      });
    },

    fechar() {
      this.$emit("fechar");
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    }
  }
};
</script>

<style scoped>
.color {
  background-color: #eaeaea;
}
.modal-participantes.dialog {
  background-color: #fff!important;
}
.modal-participantes-titulo {
  color: #fff;
}
.modal-participantes-buttons-sec {
  padding-right: 20px;
  background-color: #eee;
  display: flex;
  justify-content: flex-end;
}
.btn-modal-participantes {
  color: #00456e;
  border: 2px solid #00466E;
  transition: 0.2s all;
}
.icone-instrucional {
  cursor: help;
}
.btn-modal-participantes:hover {
  background-color: #A3C4D2;

}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalParticipantes.vue